import moment from 'jalali-moment';
import { Col, Divider, Row } from 'antd';
import { FiTrash2 } from 'react-icons/fi';
import { useCartStore } from '@/store';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { envConfig } from '@/configs';

export default function CartItem({ food, count }: { food: UserWeekReserveEntity, count: number }) {

  const removeFromCart = useCartStore(state => state.removeFromCart);
  const [t] = useTranslation(['common']);

  const getTotalPrice = () => {
    return `${((food.price * count) / 10).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}` +
      `${envConfig.ui.removeCurrency ? '' : t('common:labels.tomans')}`
  };
  const onRemove = () => removeFromCart(food.programId, 999);

  const colClasses = 'px-1 text-sm flex flex-center text-center';

  return (
    <>
      <Row className="flex px-1 py-2">
        <Col span={4} className="px-1 text-sm color-4d !flex flex-center text-center">
          {moment.from(food.programDate, 'en').format('jYYYY/jMM/jDD')}
        </Col>
        <Col span={10} className={colClasses}>{food.foodNames}</Col>
        <Col span={4} className={colClasses}>{String(count)}</Col>
        <Col span={4} className={colClasses}>{getTotalPrice()}</Col>
        <Col span={2} className={classNames(colClasses, 'cursor-pointer')} onClick={onRemove}>
          <FiTrash2 color="#FF4D4F" size="1.5rem" />
        </Col>
      </Row>
      <Divider />
    </>
  );
}
